export const daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];
export const daysOfWeekLowerCase = daysOfWeek.map((day) => day.toLowerCase());
export const daysOfWeekUpperCase = daysOfWeek.map((day) => day.toUpperCase());
//# sourceMappingURL=daysOfWeek.js.map